module.exports = __webpack_public_path__ + "img/gg.218797b3.svg";